
<div class="container pt-3">
    <div class="row justify-content-sm-center">
      <div class="col-sm-6 col-md-4">
  
        <div class="card border-info text-center">
          <div class="card-header header-color">
            Register
          </div>
          <div class="card-body">
            <!-- <img src="https://placeimg.com/128/128/tech/sepia"> -->
            <h4 class="text-center">friggkantine</h4>
            <form class="form-signin" (ngSubmit)="onSubmit(f)" #f="ngForm">
              <input type="email" class="form-control mb-2" placeholder="Email" id="email" name="email" ngModel #email="ngModel" email required autofocus>
              <input type="password" class="form-control mb-2" placeholder="Password"   id="password" name="password"  ngModel required>
              <button class="btn btn-lg button btn-block mb-1" type="submit">Sign up</button>
              <a href="#" class="float-right">Need help?</a>
            </form>
          </div>
        </div>
        <!-- <a href="#" class="float-right">Create an account </a> -->
      </div>
    </div>
  </div>
  